import { Injectable } from "@angular/core";

import { BehaviorSubject, ReplaySubject, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HeaderService {
  title: BehaviorSubject<string> = new BehaviorSubject(null);
  breadcrumbs: string;
  search: string;
  accountChanged: string;
  updateRefreshTime;
  accountsSelected: ReplaySubject<[string]> = new ReplaySubject(1);
  accountsSelectDisabled: ReplaySubject<boolean> = new ReplaySubject(1);
  accountTypes$: ReplaySubject<[string]> = new ReplaySubject(1);
  remoteActionBroadcaster: Subject<any> = new Subject();
  settlementDetail$: Subject<any> = new Subject();
  accountSelectedType: ReplaySubject<[string]> = new ReplaySubject(1);
  pauseSubj$ = new BehaviorSubject<boolean>(true);
  RefreshDropdown$=new BehaviorSubject<boolean>(false);
  isShowYearlyTrends$=new BehaviorSubject<boolean>(false); 
  showbellNotificationIcon$=new BehaviorSubject<boolean>(false); 
  amazonRegionId= new BehaviorSubject<string>(null); 
  amazonShipmentTitle: Subject<any> = new Subject();
  accountStore: ReplaySubject<string> = new ReplaySubject(null);
  refreshNotifications$: Subject<any> = new Subject();
  constructor() {}
  hideLine: Subject<any> = new Subject();
  isNewFlow:boolean=false;
  updatedSetting=new BehaviorSubject<boolean>(false);
  scanSetting=false;
  useBinLocation:boolean=false;
 
}
